import { render, staticRenderFns } from "./TrackedKeys.vue?vue&type=template&id=531d8e5c&scoped=true"
import script from "./TrackedKeys.vue?vue&type=script&lang=js"
export * from "./TrackedKeys.vue?vue&type=script&lang=js"
import style0 from "./TrackedKeys.vue?vue&type=style&index=0&id=531d8e5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d8e5c",
  null
  
)

export default component.exports